import { requestGet, requestPost } from '@/utils/request';

const api = {
    OPTS: '/system/role_opts',
    LIST: '/system/role_list',
    ADD: '/system/role_add',
    UPDATE: '/system/role_update',
    DELETE: '/system/role_del',
    IS_EXIST_NAME: '/system/role_is_exist_name',
    FUNC_LIST: '/system/role_func_list',
}

export async function roleList() {
    return requestGet(api.LIST);
}

export async function roleOpts() {
    return requestGet(api.OPTS);
}

export async function roleAdd(params) {
    return requestPost(api.ADD, params);
}

export async function roleUpdate(params) {
    return requestPost(api.UPDATE, params);
}

export async function roleDel(id) {
    let params = {id: id};
    return requestPost(api.DELETE, params);
}

export async function roleNameIsExist(name) {
    let params = {val: name};
    return requestGet(api.IS_EXIST_NAME, params);
}

export async function roleFuncList(id) {
    let params = {id: id};
    return requestGet(api.FUNC_LIST, params);
}